import { createFileRoute } from '@tanstack/react-router';
import { CnpjSearchCanvas } from '@/features/cnpj-search/components/CnpjSearchCanvas';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/cnpj-search')({
  component: CnpjSearchPage,
});

function CnpjSearchPage() {
  return (
    <PermissionGate permission={Permission.CNPJ_SEARCH_VIEW}>
      <div className="flex flex-col h-[calc(100vh-4rem)]">
        <div className="px-4 pt-4 pb-2">
          <h1 className="text-lg font-semibold">Buscador de CNPJ</h1>
          <p className="text-sm text-muted-foreground">
            Pesquise por sócio, CNPJ ou nome fantasia. Clique nos resultados para explorar sócios e empresas
            relacionadas.
          </p>
        </div>
        <div className="flex-1 min-h-0">
          <CnpjSearchCanvas />
        </div>
      </div>
    </PermissionGate>
  );
}
